// src/hooks/usePostHogPageview.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageview } from 'utils/posthog';

// Fires a PostHog $pageview on every react-router navigation. Mounted globally (via RootLayout) so
// it covers unauthenticated routes (login, password reset) that live outside UserProvider. GA
// pageviews are handled separately by useRouteTracker, which stays scoped to authenticated routes.
const usePostHogPageview = (): void => {
  const location = useLocation();

  useEffect(() => {
    capturePageview();
  }, [location]);
};

export default usePostHogPageview;
